import { render, staticRenderFns } from "./PowerDialog.vue?vue&type=template&id=64dbb6a4&scoped=true"
import script from "./PowerDialog.vue?vue&type=script&lang=js"
export * from "./PowerDialog.vue?vue&type=script&lang=js"
import style0 from "./PowerDialog.vue?vue&type=style&index=0&id=64dbb6a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dbb6a4",
  null
  
)

export default component.exports